"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lexers_1 = __importDefault(require("../lexers"));
const pickers_1 = require("../lexers/pickers");
const token_array_processors_1 = require("../tokens/token-array-processors");
const error_classes_1 = __importDefault(require("../error-classes"));
const { ExclusionsError } = error_classes_1.default;
function prepareExclusions(value, lookups) {
    var _a;
    const expression = (_a = value.exclusions) !== null && _a !== void 0 ? _a : '';
    const tokens = lexers_1.default.expression(expression);
    const dependencies = (0, pickers_1.getVariableNames)(tokens);
    const processedTokens = (0, token_array_processors_1.processExpressionTokens)(tokens, 'exclusions', lookups);
    const getExclusions = (state) => {
        const errors = [];
        let exclusions = [];
        try {
            exclusions = processedTokens.getValue(state);
            if (!Array.isArray(exclusions))
                exclusions = [exclusions];
        }
        catch (error) {
            errors.push(`There was a problem evaluating the exclusions expression.`);
        }
        if (errors.length)
            throw new ExclusionsError(errors.join(' '));
        return exclusions;
    };
    return { expression, tokens, dependencies, getExclusions };
}
exports.default = prepareExclusions;
